import WPSResource from '../../../WPS.resource';
import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import { ROOT_REDUCER_KEYS, WORKSPACE_SP_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceServicePrincipalsPutPrefix = 'WorkspaceServicePrincipalsPut';
const workspaceServicePrincipalsPutEpicReducerArg = {
    actionPrefix: workspaceServicePrincipalsPutPrefix,
    reduxKeyNested: (inputPayload) => [
        ROOT_REDUCER_KEYS.WORKSPACE_SP,
        WORKSPACE_SP_ACTION_KEYS.PUT,
    ],
    loadResource: (request) => {
        return WPSResource.putWorkspaceServicePrincipals(request.workspaceId, request.servicePrincipalId, request.data, request.identityType);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceServicePrincipalsPutEpicReducer = loadResourcesUtils(workspaceServicePrincipalsPutEpicReducerArg);

//# sourceMappingURL=PutWorkspaceServicePrincipals.ducks.js.map
